import { type ReactNode } from 'react';

import NightSkyBackground from './checkout/NightSkyBackground';

const LOGO_SRC = '/zerotail-logo-nobg.png';

export default function ErrorPageShell({
  title,
  description,
  children,
}: {
  title: string;
  description?: string;
  children?: ReactNode;
}) {
  return (
    <div className="relative isolate min-h-screen overflow-hidden bg-[#0e0e0e] text-slate-200">
      <NightSkyBackground />
      <div className="relative z-10 flex min-h-screen flex-col items-center justify-center px-4 py-12">
        <img
          src={LOGO_SRC}
          alt="ZeroTail"
          className="mb-8 h-14 w-auto drop-shadow-[0_0_24px_rgba(16,185,129,0.15)]"
          width={160}
          height={56}
        />
        <h1 className="text-2xl font-semibold tracking-tight text-slate-100">{title}</h1>
        {description && (
          <p className="mt-3 max-w-md text-center text-sm leading-relaxed text-zt-muted">
            {description}
          </p>
        )}
        {children && <div className="mt-8">{children}</div>}
      </div>
    </div>
  );
}
